export const B2B_EXPAND_NAV_DRAWER = 'B2B_EXPAND_NAV_DRAWER';
export const B2B_TOGGLE_SIDE_NAV = 'B2B_TOGGLE_SIDE_NAV';
export const B2B_SET_NAV_DRAWER = 'B2B_SET_NAV_DRAWER'

// LOGIN_USER Action Types
export const B2B_LOGIN = 'B2B_LOGIN';
export const B2B_GET_LOGIN_USER = 'B2B_GET_LOGIN_USER';
export const B2B_FETCH_LOGIN_USER = 'B2B_FETCH_LOGIN_USER';
export const B2B_SET_LOGIN_USER = 'B2B_SET_LOGIN_USER';
export const B2B_SET_USER = 'B2B_SET_USER';
export const B2B_RESET_DATA = 'B2B_RESET_DATA';
export const B2B_INSERT_LOGIN_USER = 'B2B_INSERT_LOGIN_USER';
export const B2B_UPDATE_LOGIN_USER = 'B2B_UPDATE_LOGIN_USER';
export const B2B_DELETE_LOGIN_USER = 'B2B_DELETE_LOGIN_USER';
export const B2B_SET_LOGIN_REDIRECT_ROUTE = 'B2B_SET_LOGIN_REDIRECT_ROUTE'
export const B2B_SET_REDIRECT_ROUTE = 'B2B_SET_REDIRECT_ROUTE'
export const B2B_ACTIVE_ROUTE_ITEM = 'B2B_ACTIVE_ROUTE_ITEM';
export const B2B_SET_MAIN_NAB_LIST = 'B2B_SET_MAIN_NAB_LIST';
export const B2B_SET_APP_NAV_ITEMS = 'B2B_SET_APP_NAV_ITEMS';
export const B2B_SET_APP_NAV_ITEM_EXPAND = 'B2B_SET_APP_NAV_ITEM_EXPAND';
export const B2B_ACTIVE_SUB_ROUTE_ITEM = 'B2B_ACTIVE_SUB_ROUTE_ITEM'
export const B2B_IS_LOGGED_IN = 'B2B_IS_LOGGED_IN';
export const B2B_SET_IS_LOGGED_IN = 'B2B_SET_IS_LOGGED_IN';
export const B2B_LOGGED_OUT = 'B2B_LOGGED_OUT';
export const B2B_FETCH_USER_DETAILS = 'B2B_FETCH_USER_DETAILS';
export const B2B_SET_USER_DETAILS = 'B2B_SET_USER_DETAILS';
export const B2B_SET_RESET_PASSWORD = 'B2B_SET_RESET_PASSWORD';
export const B2B_RESET_PASSWORD = 'B2B_RESET_PASSWORD';
export const B2B_SET_RESULT_RESET_PASSWORD = 'B2B_SET_RESULT_RESET_PASSWORD';
export const B2B_UPDATE_USER_INFO = 'B2B_UPDATE_USER_INFO';
export const B2B_SET_SHOW_CLOSE_ICON = 'B2B_SET_SHOW_CLOSE_ICON';

// Royalty Action Types  //
export const B2B_FETCH_ROYALTY_TOP_15_REPORT = 'B2B_FETCH_ROYALTY_TOP_15_REPORT';
export const B2B_SET_ROYALTY_TOP_15_REPORT = 'B2B_SET_ROYALTY_TOP_15_REPORT';

export const B2B_SET_SELECTED_ROYALTY_ITEM = 'B2B_SET_SELECTED_ROYALTY_ITEM';
export const B2B_SET_ROYALTY_PERIOD_ID = 'B2B_SET_ROYALTY_PERIOD_ID';
export const B2B_FETCH_ROYALTY_YEARS = 'B2B_FETCH_ROYALTY_YEARS';
export const B2B_SET_ROYALTY_YEARS = 'B2B_SET_ROYALTY_YEARS'
export const B2B_FETCH_USER_INFO = 'B2B_FETCH_USER_INFO';
export const B2B_SET_USER_INFO = 'B2B_SET_USER_INFO';
export const B2B_SET_LANGUAGES = 'B2B_SET_LANGUAGES';
export const B2B_FETCH_LANGUAGES = 'B2B_FETCH_LANGUAGES';
export const B2B_SET_LOADED_DATA = 'B2B_SET_LOADED_DATA';
export const B2B_SET_CHANNEL_LOADED_DATA = 'B2B_SET_CHANNEL_LOADED_DATA'
export const B2B_SET_LOADED_DATA_TEXT = 'B2B_SET_LOADED_DATA_TEXT'
export const B2B_FETCH_ROYALTIES_BY_YEAR = 'B2B_FETCH_ROYALTIES_BY_YEAR';
export const B2B_SET_ROYALTIES_BY_YEAR = 'B2B_SET_ROYALTIES_BY_YEAR'
export const B2B_SET_HAS_CREDIT_NOTE = 'B2B_SET_HAS_CREDIT_NOTE'
export const B2B_SET_IS_LOADED_HOME_PAGE_DATA = 'B2B_SET_IS_LOADED_HOME_PAGE_DATA'
export const B2B_SET_IS_LOADED_ROYALTY_PAGE_DATA = 'B2B_SET_IS_LOADED_ROYALTY_PAGE_DATA'
export const B2B_FETCH_HOME_PAGE_CHART = 'B2B_FETCH_HOME_PAGE_CHART';
export const B2B_FETCH_FILTERED_CHANNEL_CHART = 'B2B_FETCH_FILTERED_CHANNEL_CHART';
export const B2B_SET_FILTERED_CHANNEL_CHART = 'B2B_SET_FILTERED_CHANNEL_CHART';
export const B2B_SET_HOME_PAGE_CHART = 'B2B_SET_HOME_PAGE_CHART'
export const B2B_SET_ROYALTY_PAGE_CHART = 'B2B_SET_ROYALTY_PAGE_CHART'
